var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16V5.1L0.450005 1.75C0.333338 1.5 0.325005 1.24583 0.425005 0.9875C0.525005 0.729167 0.700005 0.541667 0.950005 0.425C1.2 0.308334 1.45417 0.295834 1.7125 0.3875C1.97084 0.479167 2.15834 0.65 2.275 0.9L4.2 5.05H15.8L17.725 0.9C17.8417 0.65 18.0292 0.475 18.2875 0.375C18.5458 0.275 18.8 0.291667 19.05 0.425C19.3 0.541667 19.475 0.729167 19.575 0.9875C19.675 1.24583 19.6667 1.5 19.55 1.75L18 5.1V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H4C3.45 18 2.97917 17.8042 2.5875 17.4125C2.19584 17.0208 2 16.55 2 16ZM8 11H12C12.2833 11 12.5208 10.9042 12.7125 10.7125C12.9042 10.5208 13 10.2833 13 10C13 9.71667 12.9042 9.47917 12.7125 9.2875C12.5208 9.09583 12.2833 9 12 9H8C7.71667 9 7.47917 9.09583 7.2875 9.2875C7.09584 9.47917 7 9.71667 7 10C7 10.2833 7.09584 10.5208 7.2875 10.7125C7.47917 10.9042 7.71667 11 8 11ZM4 16H16V7.05H4V16Z",
    fill: "#000030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.86de8e9c924c31b8917affc641406240.svg";
export { ForwardRef as ReactComponent };